<template>
  <div class="tw-m-4 card">
    <div v-if="isLoading">
      <Loader />
    </div>
    <div class="tw-p-2 tw-h-[calc(100vh-110px)]">
      <div class="tw-pb-4 tw-mb-6 tw-border-b-[1px] tw-border-[#D5D5D5]">
        <h5 class="tw-text-[#050A13] tw-text-[20px] tw-font-[500]">
          Integrations and Connected apps
        </h5>
        <p class="tw-text-[#505050] tw-text-[14px] tw-mt-2">
          Add and manage your seller and PPC accounts. Once connected you can
          automate your product review requests, track your financial data and
          monitor your products.
        </p>
      </div>
      <div v-if="platformList.length" class="tw-flex tw-flex-wrap tw-gap-6">
        <div
          v-for="platform in platformList"
          :key="platform.name"
          class="tw-px-3 tw-py-5 tw-w-[434px] tw-rounded-[5px] tw-border-[1px] tw-bg-white tw-border-[#AEAEAE]"
        >
          <div class="tw-mb-4 tw-flex tw-justify-between">
            <div>
              <img
                :src="getPlatformIcon(platform.image)"
                :alt="platform.image"
                class="tw-w-[40px] tw-h-[40px]"
              />
              <div>
                <h3
                  class="tw-text-[16px] tw-mt-2 tw-font-[500] tw-text-[#050a13] tw-capitalize"
                >
                  {{ platform.platform_name }}
                </h3>
              </div>
            </div>
            <div
              v-if="platform.connected"
              class="tw-text-[#15803D] tw-font-medium tw-bg-[#DCFCE7] tw-h-6 tw-px-2 tw-py-1 tw-rounded-[5px] tw-text-[12px]"
            >
              Connected
            </div>
          </div>
          <p class="tw-text-[#4e4e4e] tw-text-[14px] tw-leading-[1.5rem]">
            Connect account by clicking on connect
          </p>
          <button
            v-if="!platform.connected"
            class="tw-bg-primary_brand text-white tw-py-2 tw-px-4 tw-rounded-[4px] tw-text-center tw-w-full hover:tw-bg-primary_brand-80"
            @click="connectPlatform(platform.image)"
          >
            <span v-if="connectingPlatform === platform.image"
              >Connecting...</span
            >
            <span v-else>Connect</span>
          </button>
          <button
            v-else
            class="hover:tw-bg-primary_brand focus:tw-shadow-none focus:tw-outline-none focus:tw-border-primary_brand hover:tw-text-[#fff] tw-text-primary_brand tw-border-primary_brand tw-border-[1px] tw-py-2 tw-px-4 tw-rounded-[4px] tw-text-center tw-w-full"
            @click="handleManageAccount(platform)"
          >
            Manage
          </button>
        </div>
      </div>
      <div
        v-else-if="!isLoading && !platformList.length"
        class="tw-text-danger tw-flex tw-justify-center tw-border tw-border-danger tw-rounded tw-mt-4 tw-p-2 noData"
      >
        No Data Available
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import router from "../../../router";
import Loader from "../../Components/Loader.vue";

export default {
  name: "PlugNPlay",
  components: { Loader },
  data: function () {
    return {
      isLoading: false,
      platformList: [],
      viewURLForConnectAccount: "",
      connectingPlatform: null,
    };
  },
  computed: {
    ...mapState("DemoStore", ["selectedPlugNPlayPlatform"]),
  },
  mounted() {
    this.getPlatformList();
  },
  methods: {
    ...mapActions("DemoStore", ["setSelectedPlugNPlayPlatform"]),
    getPlatformList() {
      this.isLoading = true;
      const url = "/api/slate/platformstatus";
      this.$http
        .get(url)
        .then((res) => {
          this.platformList = res.data.data.platforms;
          this.isLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoading = false;
        });
    },
    getPlatformIcon(imageKey) {
      return `/slate_svg/${imageKey}.svg`;
    },
    connectPlatform(platformImage) {
      this.connectingPlatform = platformImage;
      const URLCollection = {
        amazon_ads: "/api/slate/amazon_login",
        flipkart_ads: "/api/slate/flipkart_login",
      };

      const url = URLCollection[platformImage];
      this.$http
        .get(url)
        .then((res) => {
          const authURL = res.data.data;
          const feature =
            "popup,height=600,width=800,top=200,left=400,toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,resizable=0";

          const popupWindow = window.open(authURL, "_blank", feature);
          const popupChecker = setInterval(() => {
            if (popupWindow.closed) {
              clearInterval(popupChecker);
              this.getPlatformList();
              this.connectingPlatform = null;
            }
          }, 1000);
        })
        .catch((error) => {
          console.error("Failed to get auth URL:", error);
          this.connectingPlatform = null;
        });
    },
    handleManageAccount(platform) {
      this.setSelectedPlugNPlayPlatform(platform.platform_name);
      router.push("/accounts");
    },
  },
};
</script>
<style scoped>
.card {
  border-radius: 0.7rem;
  border: none;
  margin-bottom: 1rem;
  background: #fff;
}
</style>
